const axios = require('axios')
const nuxtConfig = require('~/nuxt.config').default

export const state = () => ({
	pages: {},
	searchToggle: false,
	portfolio: []
})

export const getters = {
	data: state => (name) => state.pages[name],
	head: state => (doc) => {
		if (doc === '404') {
			return {
				htmlAttrs: {
					lang: 'th-TH'
				},
				title: state.pages[doc].title
			}
		} else if (state.pages[doc]) {
			return {
				htmlAttrs: {
					lang: 'th-TH'
				},
				title: state.pages[doc].title,
				meta: [
					{ hid: 'title', name: 'title', content: state.pages[doc].title },
					{ hid: 'description', name: 'description', content: state.pages[doc].description },
					{ hid: 'image', property: 'image', content: state.pages[doc].image },
					{ hid: 'og:title', property: 'og:title', content: state.pages[doc].title },
					{ hid: 'og:type', property: 'og:type', content: 'website' },
					{ hid: 'og:url', property: 'og:url', content: state.pages[doc].href },
					{ hid: 'og:description', property: 'og:description', content: state.pages[doc].description },
					{ hid: 'og:image', property: 'og:image', content: state.pages[doc].image },
					{ hid: 'og:image:width', property: 'og:image:width', content: '1280' },
					{ hid: 'og:image:height', property: 'og:image:height', content: '960' },
					{ hid: 'twitter:title', property: 'twitter:title', content: state.pages[doc].title },
					{ hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
					{ hid: 'twitter:url', property: 'twitter:url', content: state.pages[doc].href },
					{ hid: 'twitter:description', property: 'twitter:description', content: state.pages[doc].description },
					{ hid: 'twitter:image', property: 'twitter:image', content: state.pages[doc].image },
					...state.pages[doc].meta
				],
				link: [
					{ rel: 'canonical', href: state.pages[doc].href },
					{ rel: 'shortlink', href: state.pages[doc].href },
					{ rel: 'alternate', href: state.pages[doc].href, hreflang: 'th' }
				],
				script: state.pages[doc].script,
				__dangerouslyDisableSanitizers: ['script'], // prevent content encode
			}
		}

		return {
			htmlAttrs: {
				lang: 'th-TH'
			},
			title: 'ไม่พบหน้าที่ต้องการ'
		}
	},
	searchToggle: state => state.searchToggle,
	getPortfolioByPath: state => (path) => {
		if (state.portfolio.length === 0)
			return null

		let obj = state.portfolio.find(x => x.path === path)
		if (obj) {
			return obj
		}
		return null
	},
}

export const mutations = {
	setPageData(state, data) {
		state.pages = Object.assign(state.pages, data)
	},
	setHead(state, obj) {
		Object.entries(obj).forEach(([key,value]) => {
			state.pages[obj.doc][key] = value
		})
	},
	searchToggle (state) {
		state.searchToggle = !state.searchToggle
	},
	storePortfolio (state, data) {
		let index = state.portfolio.findIndex(x => x.path === data.path)
		if (index === -1) {
			state.portfolio.push(data)
		} else {
			state.portfolio[index] = data
		}
	}
}

export const actions = {
	// eslint-disable-next-line
	initial({ commit, state }, obj) {
		if (typeof state.pages[obj.doc] !== 'undefined' && state.pages[obj.doc].once) {
			if (obj.callback)
				obj.callback(state.pages[obj.doc])
		} else {
			commit('setPageData', {
				[obj.doc]: {
					description: obj.description || (nuxtConfig.env.pages[obj.doc].description || nuxtConfig.env.company),
					href: obj.fullPath ? `${nuxtConfig.hostname}${obj.fullPath}` : nuxtConfig.hostname,
					image: obj.image || `${nuxtConfig.hostname}/logo.png`,
					title: obj.title || (nuxtConfig.env.pages[obj.doc].title || nuxtConfig.env.company),
					script: obj.script || [],
					meta: !nuxtConfig.env.pages[obj.doc] ? [] : (nuxtConfig.env.pages[obj.doc].meta || [])
				}
			})
		}
	},

	getPortfolio ({ commit, getters }, query) {
		return new Promise((resolve, reject) => {

			let path = `${nuxtConfig.env.apiURL}/portfolio`
			if (Object.keys(query).length > 0 && query.constructor === Object) { // Has query to search
				path += '?'
				for(let key in query) {
					if (Array.isArray(query[key]) && query[key].length > 0) {
						for (let item of query[key]) {
							path += `${key}[]=${item}&`
						}
					} else {
						path += `${key}=${query[key]}&`
					}
				}
			}

			let portfolioObj = getters.getPortfolioByPath(path)
			if(portfolioObj) {
				resolve({
					data: portfolioObj.data,
					total: portfolioObj.total
				})
			} else {
				axios.get(path).then((res) => {
					let data = res.data
					commit('storePortfolio', {
						path: path,
						data: data.data,
						total: data.total
					})

					resolve(data)
				}).catch(e => {
					reject(e)
				})
			}
		})
	},
}
